<!--マイカー通勤･業務使用申請-->
<template>
  <div>
    <div class="all_area_i0008">
      <div class="el-detail_i0008">
        <el-row>
          <div class="div_span_i0008">
            <!--登録番号(ナンバープレート)-->
            <span class="input_span_i0008" style="width: 100%;">{{$t('MODULE.I0008_LBL_TEXT_A')}}</span>
          </div>
        </el-row>
        <div style="padding-top:10px;padding-bottom:10px;background: #d2eef8;">
          <el-row style="margin-left: 20px;background: #d2eef8;">
            <el-col>
              <!--例）幕張500あ-123-->
              <span class="table-label">{{$t('MODULE.I0008_LBL_TEXT_REI')}}</span>
              <el-input class="textRight_i0008" style="margin-left: 40px;width:40%;" size="small" v-model="carNo" maxlength="20"></el-input>
              <span style="color:red">＊</span>
            </el-col>
          </el-row>
        </div>
        <!--運転免許証期限-->
        <el-row>
          <div class="div_span_i0008">
            <!--運転免許証期限-->
            <span class="input_span_i0008">{{$t('MODULE.I0008_LBL_TEXT_C')}}</span>
            <!-- 写真 -->
            <span class="input_span_i0008">{{$t('MODULE.I0008_LBL_TEXT_PHOTO')}}</span>
          </div>
        </el-row>
        <!--表面-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="11" style="">
            <div class="div_input_i0008">
              <el-date-picker style="margin-left: 10px;" class="date_select_i0008 date_picker_i0008 textRight_i0008" v-model="driveLicenseExpDate" format="yyyy/MM/dd" value-format="yyyy/MM/dd" size="small" :clearable="false" :editable="false"></el-date-picker>
            </div>
            <div style="color:red;margin-top:18px;">＊</div>
          </el-col>
          <el-col :span="2" style="margin-top:18px;margin-left: 0px;">
            <div class="table-label">{{$t('MODULE.I0008_LBL_TEXT_FRONT')}}</div>
          </el-col>
          <el-col :span="10" style="margin-left: 0px;">
            <div class="div_input_i0008" style="width: 100%;">
              <div class="photo_border_i0008" :class="{'driveLicensePhoto1Css': driveLicensePhoto1Css}" v-if="!driveLicensePhoto1Url"></div>
              <el-upload class="photo_upload_i0008" ref="driveLicensePhoto1" :show-file-list="true" :file-list="driveLicensePhoto1List" list-type="picture-card" :limit="2" accept="image/jpg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'driveLicensePhoto1','1')}" :auto-upload="false" multiple>
                <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                <template slot="file" slot-scope="{file}">
                  <img id="driveLicensePhoto1Img" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'driveLicensePhoto1')"></span>
                </template>
              </el-upload>
              <!--图片预览用dialog-->
              <el-image-viewer v-if="driveLicensePhoto1Dialog" :on-close="driveLicensePhoto1PhotoDelete" :url-list="[driveLicensePhoto1Url]" />
            </div>
          </el-col>
          <el-col :span="1" style="margin-top:15px;margin-left: -5px;">
            <div style="color:red;">＊</div>
          </el-col>
        </el-row>
        <!--裏面-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="11">
            <div class="table-label" style="margin-left: 10px;margin-right: 10px;">
              {{$t('MODULE.I0008_LBL_TEXT_I')}}
            </div>
          </el-col>
          <el-col :span="2" style="margin-top:18px;margin-left:0;">
            <div class="table-label">{{$t('MODULE.I0008_LBL_TEXT_BACK')}}</div>
          </el-col>
          <el-col :span="10" style="margin-left: 0px;">
            <div class="div_input_i0008" style="width: 100%;">
              <div class="photo_border_i0008" :class="{'driveLicensePhoto2Css': driveLicensePhoto2Css}" v-if="!driveLicensePhoto2Url"></div>
              <el-upload class="photo_upload_i0008" ref="driveLicensePhoto2" :show-file-list="true" :file-list="driveLicensePhoto2List" list-type="picture-card" :limit="2" accept="image/jpg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'driveLicensePhoto2','2')}" :auto-upload="false" multiple>
                <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                <template slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'driveLicensePhoto2')"></span>
                </template>
              </el-upload>
              <!--图片预览用dialog-->
              <el-image-viewer v-if="driveLicensePhoto2Dialog" :on-close="driveLicensePhoto2PhotoDelete" :url-list="[driveLicensePhoto2Url]" />
            </div>
          </el-col>
          <el-col :span="1" style="margin-top:15px;margin-left: -5px;">
            <div style="color:red;">＊</div>
          </el-col>
        </el-row>
        <!--車検証期限-->
        <el-row>
          <div class="div_span_i0008">
            <!--車検証期限-->
            <span class="input_span_i0008">{{$t('MODULE.I0008_LBL_TEXT_D')}}</span>
            <!--写真-->
            <span class="input_span_i0008">{{$t('MODULE.I0008_LBL_TEXT_PHOTO')}}</span>
          </div>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="11">
            <div class="div_input_i0008">
              <el-date-picker style="margin-left: 10px;" class="date_select_i0008 date_picker_i0008 textRight_i0008" v-model="carVerificationExpDate" format="yyyy/MM/dd" value-format="yyyy/MM/dd" size="small" :clearable="false" :editable="false"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="2" style="margin-top:15px;margin-left: 0px;">
          </el-col>
          <el-col :span="10" style="margin-left: 0px;">
            <div class="div_input_i0008" style="width: 100%;">
              <div class="photo_border_i0008" :class="{'carVerificationPhotoCss': carVerificationPhotoCss}" v-if="!carVerificationPhotoUrl"></div>
              <el-upload class="photo_upload_i0008" ref="carVerificationPhoto" :show-file-list="true" :file-list="carVerificationPhotoList" list-type="picture-card" :limit="2" accept="image/jpg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'carVerificationPhoto','3')}" :auto-upload="false" multiple>
                <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                <template slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'carVerificationPhoto')"></span>
                </template>
              </el-upload>
              <!--图片预览用dialog-->
              <el-image-viewer v-if="carVerificationPhotoDialog" :on-close="carVerificationPhotoPhotoDelete" :url-list="[carVerificationPhotoUrl]" />
            </div>
          </el-col>
          <el-col :span="1" style="margin-top:15px;margin-left: -5px;">
            <div style="color:red;"></div>
          </el-col>
        </el-row>
        <!--2輪車に関しては下記届出を対象とする。-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;">
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_J')}}</div>
          </el-col>
        </el-row>
        <!--50cc～125cc：標識交付証明書    125cc～250cc：軽自動車届出済証-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;">
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_50')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('MODULE.I0008_LBL_TEXT_125')}}</div>
          </el-col>
        </el-row>
        <!--250cc：自動車検査証-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;margin-bottom: 10px;">
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_250')}}</div>
          </el-col>
        </el-row>
        <!--任意保険期限-->
        <el-row>
          <div class="div_span_i0008">
            <!--任意保険期限-->
            <span class="input_span_i0008">{{$t('MODULE.I0008_LBL_TEXT_E')}}</span>
            <!--写真-->
            <span class="input_span_i0008">{{$t('MODULE.I0008_LBL_TEXT_PHOTO')}}</span>
          </div>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="11">
            <div class="div_input_i0008">
              <el-date-picker style="margin-left: 10px;" class="date_select_i0008 date_picker_i0008 textRight_i0008" v-model="insuranceExpDate" format="yyyy/MM/dd" value-format="yyyy/MM/dd" size="small" :clearable="false" :editable="false"></el-date-picker>
            </div>
            <div style="color:red;margin-top:18px;">＊</div>
          </el-col>
          <el-col :span="2" style="margin-top:15px;margin-left: 0px;">
          </el-col>
          <el-col :span="10" style="margin-left: 0px;">
            <div class="div_input_i0008" style="width: 100%;">
              <div class="photo_border_i0008" :class="{'insuranceExpPhotoCss': insuranceExpPhotoCss}" v-if="!insuranceExpPhotoUrl"></div>
              <el-upload class="photo_upload_i0008" ref="insuranceExpPhoto" :show-file-list="true" :file-list="insuranceExpPhotoList" list-type="picture-card" :limit="2" accept="image/jpg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'insuranceExpPhoto','4')}" :auto-upload="false" multiple>
                <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                <template slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'insuranceExpPhoto')"></span>
                </template>
              </el-upload>
              <!--图片预览用dialog-->
              <el-image-viewer v-if="insuranceExpPhotoDialog" :on-close="insuranceExpPhotoPhotoDelete" :url-list="[insuranceExpPhotoUrl]" />
            </div>
          </el-col>
          <el-col :span="1" style="margin-top:15px;margin-left: -5px;">
            <div style="color:red;">＊</div>
          </el-col>
        </el-row>
        <!--任意保険期限写真2-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="11">
          </el-col>
          <el-col :span="2" style="margin-top:15px;margin-left: 0px;">
          </el-col>
          <el-col :span="10" style="margin-left: 0px;">
            <div class="div_input_i0008" style="width: 100%;">
              <div class="photo_border_i0008" :class="{'insuranceExpPhoto2Css': insuranceExpPhoto2Css}" v-if="!insuranceExpPhoto2Url"></div>
              <el-upload class="photo_upload_i0008" ref="insuranceExpPhoto2" :show-file-list="true" :file-list="insuranceExpPhoto2List" list-type="picture-card" :limit="2" accept="image/jpg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'insuranceExpPhoto2','5')}" :auto-upload="false" multiple>
                <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                <template slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'insuranceExpPhoto2')"></span>
                </template>
              </el-upload>
              <!--图片预览用dialog-->
              <el-image-viewer v-if="insuranceExpPhoto2Dialog" :on-close="insuranceExpPhoto2PhotoDelete" :url-list="[insuranceExpPhoto2Url]" />
            </div>
          </el-col>
          <el-col :span="1" style="margin-top:15px;margin-left: -5px;">
            <div style="color:red;"></div>
          </el-col>
        </el-row>
        <!--添付ファイル(PDF)-->
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="23" style="margin-bottom:10px">
            <el-upload action="string" accept=".pdf,.PDF" :on-preview="onPreviewPdfFile" :file-list="filePdfList" :on-change="(file, fileList) => {handleChangePdf(file, fileList)}" :on-remove="onRemovePdffile" :auto-upload="false" :limit="5" multiple list-type="text">
              <el-button type="primary" class="css-button css-btn" style="width:110px;font-size:10pt;margin-left:10px;" size="small">{{$t('MODULE.I0008_BTN_FILE')}}</el-button>
            </el-upload>
          </el-col>
          <el-col :span="1" style="margin-top:15px;margin-left: -5px;">
            <div style="color:red;"></div>
          </el-col>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;margin-bottom:10px;">
            <!--契約者名・有効期限・車両番号・補償内容(対人・対物・障害補償)の確認を行います。記載が2枚もしくは表裏にわたっている場合はそれぞれ写真を撮影してください。-->
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_KEIYAKUSHAMEI')}}</div>
          </el-col>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;margin-bottom:10px;">
            <!--任意保険条件内容-->
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_N')}}</div>
          </el-col>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;">
            <!--1．対人保証：無制限-->
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_O')}}</div>
          </el-col>
          <el-col :span="24" style="margin-left: 10px;">
            <el-radio v-model="persionalInsurance" label="1">
              <span class="table-label">{{$t('MODULE.I0013_BTN_YES')}}</span>
            </el-radio>
            <el-radio v-model="persionalInsurance" label="2">
              <span class="table-label" style="">{{$t('MODULE.I0013_BTN_NO')}}</span>
            </el-radio>
          </el-col>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;">
            <!--2．対物保証：無制限-->
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_P')}}</div>
          </el-col>
          <el-col :span="24" style="margin-left: 10px;">
            <el-radio v-model="othersInsurance" label="1">
              <span class="table-label">{{$t('MODULE.I0013_BTN_YES')}}</span>
            </el-radio>
            <el-radio v-model="othersInsurance" label="2">
              <span class="table-label">{{$t('MODULE.I0013_BTN_NO')}}</span>
            </el-radio>
          </el-col>
        </el-row>
        <el-row type="flex" style="background: #d2eef8;">
          <el-col :span="24" style="margin-left: 10px;">
            <!--3．人身傷害補償または搭乗者傷害補償加入-->
            <div class="table-label" style="width:100%">{{$t('MODULE.I0008_LBL_TEXT_Q')}}</div>
          </el-col>
          <el-col :span="24" style="margin-left: 10px;margin-bottom: 10px;">
            <el-radio v-model=" personalInjuryCompensation" label="1">
              <span class="table-label">{{$t('MODULE.I0013_BTN_YES')}}</span>
            </el-radio>
            <el-radio v-model="personalInjuryCompensation" label="2">
              <span class="table-label">{{$t('MODULE.I0013_BTN_NO')}}</span>
            </el-radio>
          </el-col>
        </el-row>
      </div>
      <!--申請中-->
      <span class="table-label" v-if="this.processCd == 1">{{this.statusName}}&nbsp;{{this.timeShow}}</span>
      <!--申請-->
      <div>
        <el-row style="text-align:center;">
          <el-button class="css-btn css-button" type="primary" :disabled="this.processCd == 1 && this.status == 2" style="margin-top: 8px;font-size:13px;width:20%" @click="save_click">{{$t('MODULE.I0008_BTN_APPLICATION')}}</el-button>
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size:13px;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
        </el-row>
      </div>
    </div>
    <el-dialog fullscreen :visible.sync="viewVisible" :close-on-click-modal="false" :show-close="false" width="100%" top="52px" height="120%">
      <Pdf :src="pdfUrl" @pdfClose="pdfClose"></Pdf>
    </el-dialog>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0008"
import css from "@/statics/css"
import pdf from '@/components/page/pdf'
import utils from '../../common/utils'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import imageCompression from 'browser-image-compression';
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  components: {
    ElImageViewer,
    Pdf: pdf
  },
  data() {
    return {
      obj: [],
      fileList: [],//放大图片

      driveLicensePhoto1Css: true,//图片边框样式
      driveLicensePhoto2Css: true,
      carVerificationPhotoCss: true,
      insuranceExpPhotoCss: true,
      insuranceExpPhoto2Css: true,

      driveLicensePhoto1Url: '',//图片URL
      driveLicensePhoto2Url: '',
      carVerificationPhotoUrl: '',
      insuranceExpPhotoUrl: '',
      insuranceExpPhoto2Url: '',

      driveLicensePhoto1Dialog: false,//照片查看Dialog
      driveLicensePhoto2Dialog: false,
      carVerificationPhotoDialog: false,
      insuranceExpPhotoDialog: false,
      insuranceExpPhoto2Dialog: false,

      changeFlg: false,
      driveLicensePhoto1List: [],
      driveLicensePhoto2List: [],
      carVerificationPhotoList: [],
      insuranceExpPhotoList: [],
      insuranceExpPhoto2List: [],
      photoListSave: [],

      driveLicensePhoto1Image: {},
      driveLicensePhoto2Image: {},
      carVerificationPhotoImage: {},
      insuranceExpPhotoImage: {},
      insuranceExpPhoto2Image: {},

      privateCarInfoData: {},

      carNo: '',//マイカー番号
      driveLicenseExpDate: '',//免許証期限
      driveLicensePhoto1: '',//免許証写真1
      driveLicensePhoto2: '',//免許証写真2
      carVerificationExpDate: '',//車検証期限
      carVerificationPhoto: '',//車検証写真
      insuranceExpDate: '',//保険期限
      insuranceExpPhoto: '',//保険写真
      insuranceExpPhoto2: '',//保険写真2
      persionalInsurance: '',//対人保証
      othersInsurance: '',//対物保証
      personalInjuryCompensation: '',//人身傷害補償
      applyDate: '',//申請日時
      id: '',//申請番号
      processCd: '',//処理区分
      status: '',//ステータス
      statusName: '',//ステータス名
      confirmDate: '',//確認日時
      updateDate: '',//更新日時
      userCd: '',
      timeShow: '',//日時表示
      updateChange: {},//用来判断返回上个页面时，页面是否与初始查询的数据有变更
      //文件上传
      filesPdf: [],//更新时文件list
      filePdfList: [],//检索文件list
      blobFile: {},
      fileTotal: 0,//文件总大小
      filePdfUrl: "",
      timeFormat: 0,
      //PDF
      viewVisible: false,
      pdfUrl: '',
    }
  },
  methods: {
    // 画像文件之前的钩子
    handleChange(file, fileList, itemName, type) {
      var file_type = file.raw.type
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        if (file.status === "ready") {
          // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
          if (fileList.length === 2) {
            fileList.shift();
          }
        }
        this[itemName + 'Url'] = file.url
        var that = this
        // 写真パス：「image/userInfo/社員コード/mycar/drivelicense1_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/drivelicense2_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/carverification_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/insurance_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/insurance2_yyyymmddhhmmssfff.jpg」
        this.getBase64(file.raw).then(async res => {
          // 压缩设定
          var options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
          }
          // 压缩图片
          var photo = await imageCompression(file.raw, options).catch(() => {
            this.$message.error({ message: this.$t('COMMON.MSG_CURD_ERROR'), showClose: true });
          });

          let files = new window.File([photo], file.name, { type: file.type })

          let photoPath = ''
          //拡張子
          var exhibitionName = file.name.split('.')[1];

          if (type == '1') {
            //運転免許証期限表面写真
            photoPath = url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'drivelicense1' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
            this.driveLicensePhoto1Image = {};
            this.driveLicensePhoto1Image.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
            this.driveLicensePhoto1Image.files = files;
            this.driveLicensePhoto1Image.photoId = "1";
            this.driveLicensePhoto1Image.photoPath = photoPath;
            this.driveLicensePhoto1Image.type = "1";
          } else if (type == '2') {
            //運転免許証期限裏面写真
            photoPath = url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'drivelicense2' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
            this.driveLicensePhoto2Image = {};
            this.driveLicensePhoto2Image.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
            this.driveLicensePhoto2Image.files = files;
            this.driveLicensePhoto2Image.photoId = "2";
            this.driveLicensePhoto2Image.photoPath = photoPath;
            this.driveLicensePhoto2Image.type = "2";
          } else if (type == '3') {
            //車検証期限写真
            photoPath = url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'carverification' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
            this.carVerificationPhotoImage = {};
            this.carVerificationPhotoImage.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
            this.carVerificationPhotoImage.files = files;
            this.carVerificationPhotoImage.photoId = "3";
            this.carVerificationPhotoImage.photoPath = photoPath;
            this.carVerificationPhotoImage.type = "3";
          } else if (type == '4') {
            //任意保険期限写真1
            photoPath = url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'insurance' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
            this.insuranceExpPhotoImage = {};
            this.insuranceExpPhotoImage.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
            this.insuranceExpPhotoImage.files = files;
            this.insuranceExpPhotoImage.photoId = "4";
            this.insuranceExpPhotoImage.photoPath = photoPath;
            this.insuranceExpPhotoImage.type = "4";
          } else if (type == '5') {
            //任意保険期限写真2
            photoPath = url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'insurance2' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
            this.insuranceExpPhoto2Image = {};
            this.insuranceExpPhoto2Image.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
            this.insuranceExpPhoto2Image.files = files;
            this.insuranceExpPhoto2Image.photoId = "5";
            this.insuranceExpPhoto2Image.photoPath = photoPath;
            this.insuranceExpPhoto2Image.type = "5";
          }
        });
      }
    },
    //选择PDF文件
    handleChangePdf(file, fileList) {
      this.changeFlg = true;
      var that = this
      this.filesPdf = [];
      this.fileTotal = 0;
      this.filePdfUrl = "";
      this.filePdfList = fileList;
      this.timeFormat = Number(this.dateFormat())
      for (var item of fileList) {
        // 计算文件总大小
        if (item.status == 'success') {
          this.fileTotal = this.fileTotal + new Blob([item.url]).size
        } else {
          this.fileTotal = this.fileTotal + item.size
          this.filesPdf.push(item)
        }

        this.timeFormat = this.timeFormat + 1
        if (!item.raw) {
          let raw = new window.File([item], item.name, { type: item.type })
          item.fileName = item.name
          item.file = raw
          item.size = raw.size
          item.filePath = item.filePath
        } else {
          // 假设`items`是包含文件信息的数组
          var nameParts = item.name.split('.');
          var extension = nameParts[nameParts.length - 1];
          if (!this.isValidExtension(item.name)) {
            //不合法的文件
            extension = 'aaa'
          }
          //image/userInfo/社員コード/mycar/yyyymmddhhmmssfff.拡張子
          item.filePath = url.imgUrl_UserInfo + that.userCd + '/mycar/' + this.timeFormat + '.' + extension;
          item.file = item.raw
        }

        if (this.filePdfUrl) {
          this.filePdfUrl = this.filePdfUrl + ',' + item.filePath
        } else {
          this.filePdfUrl = item.filePath
        }
      }
    },
    // 检查扩展名是否存在，即确保文件名包含至少一个'.'
    isValidExtension(name) {
      const parts = name.split('.');
      return parts.length > 1;
    },
    //移除PDF文件
    onRemovePdffile(file, fileList) {
      this.handleChangePdf(file, fileList)
    },
    //浏览PDF文件
    onPreviewPdfFile(file) {
      if (file.status == 'ready') {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_VIEW'), showClose: true });
        return
      }
      this.pdfUrl = file
      this.viewVisible = true
    },
    pdfClose() {
      this.pdfUrl = ""
      this.viewVisible = false
    },
    //時間フォーマット
    dateFormat() {
      this.time_Format = new Date();
      let date = new Date();
      let yyyy = date.getFullYear().toString();
      let mm = (date.getMonth() + 1).toString().padStart(2, '0');
      let dd = date.getDate().toString().padStart(2, '0');
      let hh = date.getHours().toString().padStart(2, '0');
      let min = date.getMinutes().toString().padStart(2, '0');
      let sss = date.getMilliseconds().toString().padStart(3, '0');
      return yyyy + mm + dd + hh + min + sss;
    },
    // 图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // base转blob
    base64ToBlob(file) {
      let byteString;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1])
      } else {
        byteString = unescape(file.split(',')[1])
      }
      let mimeString = file
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },
    //单张图片点击
    handlePictureCardPreview(file, dialogName) {
      this[dialogName + 'Url'] = file.url;
      this[dialogName + 'Dialog'] = true;
    },
    // 検索
    query() {
      //实现Loading 加载方法
      this.set_loading();
      this.changeFlg = false;
      this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
      // 検索処理
      amsApi.i_0008_privateCarInfoQuery(this.userCd).then(res => {
        if (res.code == 204) {
          this.privateCarInfoData = res.items.privateCarInfo[0];
          this.updateChange = JSON.parse(JSON.stringify(res.items.privateCarInfo[0]));

          this.carNo = this.privateCarInfoData.carNo;

          if (this.privateCarInfoData.driveLicenseExpDate == null) {
            this.driveLicenseExpDate = "";
          } else {
            this.driveLicenseExpDate = this.privateCarInfoData.driveLicenseExpDate.replace(new RegExp("-", 'g'), "/");
          }

          if (this.privateCarInfoData.carVerificationExpDate == null) {
            this.carVerificationExpDate = "";
          } else {
            this.carVerificationExpDate = this.privateCarInfoData.carVerificationExpDate.replace(new RegExp("-", 'g'), "/");
          }

          if (this.privateCarInfoData.insuranceExpDate == null) {
            this.insuranceExpDate = "";
          } else {
            this.insuranceExpDate = this.privateCarInfoData.insuranceExpDate.replace(new RegExp("-", 'g'), "/");
          }

          this.persionalInsurance = this.privateCarInfoData.persionalInsurance;
          this.othersInsurance = this.privateCarInfoData.othersInsurance;
          this.personalInjuryCompensation = this.privateCarInfoData.personalInjuryCompensation;

          this.applyDate = this.privateCarInfoData.applyDate;
          if (this.privateCarInfoData.id == null) {
            this.id = "";
          } else {
            this.id = this.privateCarInfoData.id;
          }

          this.processCd = this.privateCarInfoData.processCd;


          this.status = this.privateCarInfoData.status;
          this.statusName = this.privateCarInfoData.statusName;
          this.confirmDate = this.privateCarInfoData.confirmDate;
          this.updateDate = this.privateCarInfoData.updateDate;

          // 処理区分が「1：更新」表示日時
          // ステータス取得
          // 「0」の場合 申請日時
          // 「1」or「2」の場合 確認日時
          if (this.processCd == "1") {
            if (this.status == "0") {
              this.timeShow = utils.extractMillisecond(this.applyDate);
            } else if (this.status == "1" || this.status == "2") {
              this.timeShow = utils.extractMillisecond(this.confirmDate);
            }
          }

          //照片
          // this.driveLicensePhoto1 = this.privateCarInfoData.driveLicensePhoto1;
          // this.driveLicensePhoto2 = this.privateCarInfoData.driveLicensePhoto2;
          // this.carVerificationPhoto = this.privateCarInfoData.carVerificationPhoto;
          // this.insuranceExpPhoto = this.privateCarInfoData.insuranceExpPhoto;
          // this.insuranceExpPhoto2 = this.privateCarInfoData.insuranceExpPhoto2;

          // 清空原照片数据，取最新数据
          this.photoInit()
          //写真パスより、写真を取得する。
          if (this.privateCarInfoData.driveLicensePhoto1 != '' && this.privateCarInfoData.driveLicensePhoto1 != null) {
            this.fileQuery(this.privateCarInfoData.driveLicensePhoto1, "1");
          }
          if (this.privateCarInfoData.driveLicensePhoto2 != '' && this.privateCarInfoData.driveLicensePhoto2 != null) {
            this.fileQuery(this.privateCarInfoData.driveLicensePhoto2, "2");
          }
          if (this.privateCarInfoData.carVerificationPhoto != '' && this.privateCarInfoData.carVerificationPhoto != null) {
            this.fileQuery(this.privateCarInfoData.carVerificationPhoto, "3");
          }
          if (this.privateCarInfoData.insuranceExpPhoto != '' && this.privateCarInfoData.insuranceExpPhoto != null) {
            this.fileQuery(this.privateCarInfoData.insuranceExpPhoto, "4");
          }
          if (this.privateCarInfoData.insuranceExpPhoto2 != '' && this.privateCarInfoData.insuranceExpPhoto2 != null) {
            this.fileQuery(this.privateCarInfoData.insuranceExpPhoto2, "5");
          }

          //PDFFILE
          this.filePdfUrl = ""
          this.filePdfList = []
          if (this.privateCarInfoData.insuranceExpFile != null && this.privateCarInfoData.insuranceExpFile.length != 0) {
            this.filePdfUrl = this.privateCarInfoData.insuranceExpFile;
            var tempList = []
            this.blobFile = {};
            this.filePdfList = []
            for (var item of this.privateCarInfoData.insuranceExpFile.split(',')) {
              if (tempList.indexOf(item) == -1) {
                tempList.push(item)
              }
            }
            for (var i = 0; i < tempList.length; i++) {
              //ファイル名取得
              var fileName = tempList[i].split('/')[tempList[i].split('/').length - 1];
              var PathfileName = tempList[i];
              this.blobFile[fileName] = PathfileName;
            }
            var sum = 0
            for (var key in this.blobFile) {
              let fileUrl = {};
              fileUrl.name = key;
              fileUrl.filePath = this.blobFile[key]
              amsApi.i_0008_photoFile_get(this.blobFile[key]).then(res_file => {
                sum += 1
                let blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' })
                let url = window.URL.createObjectURL(blob);
                fileUrl.url = url;
                if (fileUrl.name.indexOf("%26") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%26', '&')
                }
                if (fileUrl.name.indexOf("%2F") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%2F', '/')
                }
                if (fileUrl.name.indexOf("%3F") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%3F', '?')
                }
                if (fileUrl.name.indexOf("%23") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%23', '#')
                }
                if (fileUrl.name.indexOf("%25") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%25', '%')
                }

                this.filePdfList.push(fileUrl);

                if (sum == tempList.length) {
                  this.close_loading()
                }
              }).catch((err) => {
                //关闭loading
                this.close_loading()
              });
            }
          }
        } else if (res.code === 300) {
          this.close_loading();
          this.confirmAlert(this.$t('COMMON.NO_TARGET_DATA'));
          return
        }
        this.close_loading();
      }).catch((error) => {
        this.close_loading();
      });
    },

    //文件查询
    fileQuery(filePath, filePathType) {
      this.set_loading();
      amsApi.i_0008_photoFile_get(filePath).then(res => {
        let blob = new Blob([res], { type: 'image/jpg' })
        var url = window.URL.createObjectURL(blob)

        var fileName = filePath.substring(filePath.lastIndexOf("/") + 1)

        if (filePathType == '1') {
          //運転免許証期限表面写真
          this.driveLicensePhoto1List.push({ url: url });
          this.driveLicensePhoto1Url = filePath;

          this.driveLicensePhoto1Image = {};
          this.driveLicensePhoto1Image.name = fileName;
          this.driveLicensePhoto1Image.files = blob;
          this.driveLicensePhoto1Image.photoId = "1";
          this.driveLicensePhoto1Image.photoPath = filePath;
          this.driveLicensePhoto1Image.type = "1";
        } else if (filePathType == '2') {
          //運転免許証期限裏面写真
          this.driveLicensePhoto2List.push({ url: url });
          this.driveLicensePhoto2Url = filePath;

          this.driveLicensePhoto2Image = {};
          this.driveLicensePhoto2Image.name = fileName;
          this.driveLicensePhoto2Image.files = blob;
          this.driveLicensePhoto2Image.photoId = "2";
          this.driveLicensePhoto2Image.photoPath = filePath;
          this.driveLicensePhoto2Image.type = "2";
        } else if (filePathType == '3') {
          //車検証期限写真
          this.carVerificationPhotoList.push({ url: url });
          this.carVerificationPhotoUrl = filePath;

          this.carVerificationPhotoImage = {};
          this.carVerificationPhotoImage.name = fileName;
          this.carVerificationPhotoImage.files = blob;
          this.carVerificationPhotoImage.photoId = "3";
          this.carVerificationPhotoImage.photoPath = filePath;
          this.carVerificationPhotoImage.type = "3";
        } else if (filePathType == '4') {
          //任意保険期限写真1
          this.insuranceExpPhotoList.push({ url: url });
          this.insuranceExpPhotoUrl = filePath;

          this.insuranceExpPhotoImage = {};
          this.insuranceExpPhotoImage.name = fileName;
          this.insuranceExpPhotoImage.files = blob;
          this.insuranceExpPhotoImage.photoId = "4";
          this.insuranceExpPhotoImage.photoPath = filePath;
          this.insuranceExpPhotoImage.type = "4";
        } else if (filePathType == '5') {
          //任意保険期限写真2
          this.insuranceExpPhoto2List.push({ url: url });
          this.insuranceExpPhoto2Url = filePath;

          this.insuranceExpPhoto2Image = {};
          this.insuranceExpPhoto2Image.name = fileName;
          this.insuranceExpPhoto2Image.files = blob;
          this.insuranceExpPhoto2Image.photoId = "5";
          this.insuranceExpPhoto2Image.photoPath = filePath;
          this.insuranceExpPhoto2Image.type = "5";
        }
        this.close_loading()
      }).catch((error) => {
        this.close_loading()
      })
    },

    // 照片检索前数据初始化
    photoInit() {
      this.driveLicensePhoto1List = []
      this.driveLicensePhoto2List = []
      this.carVerificationPhotoList = []
      this.insuranceExpPhotoList = []
      this.insuranceExpPhoto2List = []
      this.driveLicensePhoto1Url = ''
      this.driveLicensePhoto2Url = ''
      this.carVerificationPhotoUrl = ''
      this.insuranceExpPhotoUrl = ''
      this.insuranceExpPhoto2Url = ''
    },

    // 退出登录处理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
    // 戻る処理
    back_click() {
      if (this.updateChange.carNo == null) {
        this.updateChange.carNo = "";
      }
      if (this.updateChange.driveLicenseExpDate == null) {
        this.updateChange.driveLicenseExpDate = "";
      }
      if (this.updateChange.carVerificationExpDate == null) {
        this.updateChange.carVerificationExpDate = "";
      }
      if (this.updateChange.insuranceExpDate == null) {
        this.updateChange.insuranceExpDate = "";
      }
      if (this.carNo == null) {
        this.carNo = "";
      }
      if (this.driveLicenseExpDate == null) {
        this.driveLicenseExpDate = "";
      }
      if (this.carVerificationExpDate == null) {
        this.carVerificationExpDate = "";
      }
      if (this.insuranceExpDate == null) {
        this.insuranceExpDate = "";
      }
      if (this.updateChange.carNo != this.carNo || this.updateChange.driveLicenseExpDate.replace(new RegExp("-", 'g'), "/") != this.driveLicenseExpDate ||
        this.updateChange.carVerificationExpDate.replace(new RegExp("-", 'g'), "/") != this.carVerificationExpDate || this.updateChange.insuranceExpDate.replace(new RegExp("-", 'g'), "/") != this.insuranceExpDate) {
        this.changeFlg = true
      }

      if (this.changeFlg == true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: 'true'
        }).then(() => {
          var vm = this
          vm.$router.push({ path: url.routerUrl_I0013 });
        }).catch(() => {

        });
      } else {
        var vm = this
        vm.$router.push({ path: url.routerUrl_I0013 });
      }
    },

    // 保存按钮事件
    save_click() {
      //チェック処理
      if (!this.saveCheck()) {
        return
      }
      this.saveConfirm()
    },

    // 保存确认提示
    saveConfirm() {
      // 保存処理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), {//保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: 'true'
      }).then(() => {
        // 保存时先进行图片上传，成功之后进行数据更新
        this.photoSave();
      }).catch(() => {
        // 取消
      });
    },

    //数据更新
    dataSave() {
      var update_params = {};

      update_params.userCd = this.userCd;
      update_params.carNo = this.carNo;
      update_params.driveLicenseExpDate = this.driveLicenseExpDate;
      update_params.carVerificationExpDate = this.carVerificationExpDate;
      update_params.insuranceExpDate = this.insuranceExpDate;
      update_params.insuranceExpFile = this.filePdfUrl;
      update_params.persionalInsurance = this.persionalInsurance;
      update_params.othersInsurance = this.othersInsurance;
      update_params.personalInjuryCompensation = this.personalInjuryCompensation;

      update_params.processCd = this.processCd;
      update_params.id = this.id;
      if (this.processCd == "2") {
        update_params.updateDate = "";
      } else {
        update_params.updateDate = this.updateDate;
      }

      update_params.driveLicensePhoto1 = this.photoListSave[0].photoPath;
      update_params.driveLicensePhoto2 = this.photoListSave[1].photoPath;
      update_params.carVerificationPhoto = this.photoListSave[2].photoPath;
      update_params.insuranceExpPhoto = this.photoListSave[3].photoPath;
      update_params.insuranceExpPhoto2 = this.photoListSave[4].photoPath;

      //图片没有变更不用再保存
      if (this.updateChange.driveLicensePhoto1 != null && this.updateChange.driveLicensePhoto1 == this.photoListSave[0].photoPath) {
        update_params.driveLicensePhoto1 = null;
      }
      if (this.updateChange.driveLicensePhoto2 != null && this.updateChange.driveLicensePhoto2 == this.photoListSave[1].photoPath) {
        update_params.driveLicensePhoto2 = null;
      }
      if (this.updateChange.carVerificationPhoto != null && this.updateChange.carVerificationPhoto == this.photoListSave[2].photoPath) {
        update_params.carVerificationPhoto = null;
      }
      if (this.updateChange.insuranceExpPhoto != null && this.updateChange.insuranceExpPhoto == this.photoListSave[3].photoPath) {
        update_params.insuranceExpPhoto = null;
      }
      if (this.updateChange.insuranceExpPhoto2 != null && this.updateChange.insuranceExpPhoto2 == this.photoListSave[4].photoPath) {
        update_params.insuranceExpPhoto2 = null;
      }
      //删除图片的场合
      //New Add
      if (this.updateChange.driveLicensePhoto1 != null && this.photoListSave[0].photoPath == undefined) {
        update_params.driveLicensePhoto1 = "";
      }
      //New Add
      if (this.updateChange.driveLicensePhoto2 != null && this.photoListSave[1].photoPath == undefined) {
        update_params.driveLicensePhoto2 = "";
      }
      if (this.updateChange.carVerificationPhoto != null && this.photoListSave[2].photoPath == undefined) {
        update_params.carVerificationPhoto = "";
      }
      //New Add
      if (this.updateChange.insuranceExpPhoto != null && this.photoListSave[3].photoPath == undefined) {
        update_params.insuranceExpPhoto = "";
      }
      if (this.updateChange.insuranceExpPhoto2 != null && this.photoListSave[4].photoPath == undefined) {
        update_params.insuranceExpPhoto2 = "";
      }

      amsApi.i_0008_update(update_params).then(res => {
        this.res_code_back(res)
      }).catch((err) => {
        //关闭loading
        this.close_loading();
      });
    },
    // res_code処理
    res_code_back(res) {
      if (res.code === 202) {
        this.changeFlg = false;
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
        this.query()
      } else if (res.code === 308) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(() => {
            this.query()
          }).catch(() => {
            this.close_loading()
          })
        }, 500)
      } else if (res.code === 311) {
        setTimeout(() => {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
          this.close_loading()
        }, 500)
      }
    },

    //图片保存
    photoSave() {
      var photoList = [];

      this.photoListSave = [];
      this.photoListSave.push(this.driveLicensePhoto1Image);
      this.photoListSave.push(this.driveLicensePhoto2Image);
      this.photoListSave.push(this.carVerificationPhotoImage);
      this.photoListSave.push(this.insuranceExpPhotoImage);
      this.photoListSave.push(this.insuranceExpPhoto2Image);

      //初始化的图片与当前画面图片名称一样则不上传
      if (this.driveLicensePhoto1Image.photoPath == this.privateCarInfoData.driveLicensePhoto1) {
        this.driveLicensePhoto1Image = {};
      }
      if (this.driveLicensePhoto2Image.photoPath == this.privateCarInfoData.driveLicensePhoto2) {
        this.driveLicensePhoto2Image = {};
      }
      if (this.carVerificationPhotoImage.photoPath == this.privateCarInfoData.carVerificationPhoto) {
        this.carVerificationPhotoImage = {};
      }
      if (this.insuranceExpPhotoImage.photoPath == this.privateCarInfoData.insuranceExpPhoto) {
        this.insuranceExpPhotoImage = {};
      }
      if (this.insuranceExpPhoto2Image.photoPath == this.privateCarInfoData.insuranceExpPhoto2) {
        this.insuranceExpPhoto2Image = {};
      }

      photoList.push(this.driveLicensePhoto1Image);
      photoList.push(this.driveLicensePhoto2Image);
      photoList.push(this.carVerificationPhotoImage);
      photoList.push(this.insuranceExpPhotoImage);
      photoList.push(this.insuranceExpPhoto2Image);

      var photoFormData = new FormData()

      var photoSum = 0
      //写真
      for (let i = 0; i < photoList.length; i++) {
        if (photoList[i] && photoList[i].files) {
          photoSum = photoSum + 1
          photoFormData.append('files', photoList[i].files, photoList[i].photoPath);
        }
      }

      //保険ファイル
      for (var item of this.filesPdf) {
        photoSum = photoSum + 1
        photoFormData.append('files', item.file, item.filePath)
      }

      if (photoSum > 0) {
        //实现Loading 加载方法
        this.set_loading();
        amsApi.i_0008_saveImage(photoFormData).then(res => {
          if (res.code == 205) {
            this.dataSave()
          } else if (res.code == 311) {
            //图片上传失败
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
            this.close_loading()
          }
        }).catch((err) => {
          //关闭loading
          this.close_loading();
        });
      } else {
        //实现Loading 加载方法
        this.set_loading();
        this.dataSave();
      }
    },

    //保存check
    saveCheck() {
      var flag = true
      //必須入力 登録番号
      if (!this.carNo) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_A_VALIDITY')), showClose: true });
        return flag = false
      }
      //必須入力 運転免許証期限
      if (!this.driveLicenseExpDate) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_B_VALIDITY')), showClose: true });
        return flag = false
      }
      if (this.updateChange.driveLicenseExpDate == null) {
        this.updateChange.driveLicenseExpDate = "";
      }
      //「運転免許証期限」が変更した場合、免許証表面写真、裏面写真が必須；　変更無しの場合、必須ではない
      if (this.driveLicenseExpDate != this.updateChange.driveLicenseExpDate.replace(new RegExp("-", 'g'), "/")) {
        //必須入力 免許証表面写真
        if (!this.driveLicensePhoto1Url) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_C_VALIDITY')), showClose: true });
          return flag = false
        }
        //必須入力 免許証裏面写真
        if (!this.driveLicensePhoto2Url) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_D_VALIDITY')), showClose: true });
          return flag = false
        }
      } else {
        //免許証表面写真 存在-->なし
        if (this.driveLicensePhoto1Url == "" && !utils.isEmpty(this.updateChange.driveLicensePhoto1)) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_C_VALIDITY')), showClose: true });
          return flag = false
        }
        //免許証裏面写真 存在-->なし
        if (this.driveLicensePhoto2Url == "" && !utils.isEmpty(this.updateChange.driveLicensePhoto2)) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_D_VALIDITY')), showClose: true });
          return flag = false
        }
        if (utils.isEmpty(this.updateChange.driveLicensePhoto1) && utils.isEmpty(this.updateChange.driveLicensePhoto2)) {
          if (!this.driveLicensePhoto1Url && !!this.driveLicensePhoto2Url) {
            //免許証表面写真 存在-->なし
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_C_VALIDITY')), showClose: true });
            return flag = false
          } else if (!!this.driveLicensePhoto1Url && !this.driveLicensePhoto2Url) {
            //免許証裏面写真 存在-->なし
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_D_VALIDITY')), showClose: true });
            return flag = false
          } else if (this.driveLicensePhoto1Url == "" && this.driveLicensePhoto2Url == "") {
          }
        }
      }
      //必須入力 任意保険期限
      if (!this.insuranceExpDate) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_G_VALIDITY')), showClose: true });
        return flag = false
      }
      if (this.updateChange.insuranceExpDate == null) {
        this.updateChange.insuranceExpDate = "";
      }
      //「任意保険期限」が変更した場合、保険写真と保険ファイルの片方が必須；　変更無しの場合、必須ではない
      if (this.insuranceExpDate != this.updateChange.insuranceExpDate.replace(new RegExp("-", 'g'), "/")) {
        //保険写真と保険ファイル両方が入力されていない場合 エラーメッセージを表示し
        if (!this.insuranceExpPhotoUrl && !this.filePdfUrl && this.filePdfList.length == 0) {
          //保険写真或いは保険ファイルのいずれを入力してください。
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0008_MSG_H_VALIDITY')).replace('{2}', this.$t('MODULE.I0008_MSG_FILE_VALIDITY')), showClose: true })
          return flag = false
        }
      } else {
        //存在-->なし NG
        if ((!this.insuranceExpPhotoUrl && !this.filePdfUrl && this.filePdfList.length == 0)){
          if(!(!this.updateChange.insuranceExpPhoto && !this.updateChange.insuranceExpFile)) {
            //保険写真或いは保険ファイルのいずれを入力してください。
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0008_MSG_H_VALIDITY')).replace('{2}', this.$t('MODULE.I0008_MSG_FILE_VALIDITY')), showClose: true })
            return flag = false
          }
        }
      }
      //保険ファイルを添付した場合、保険ファイル拡張子はPDF
      if (this.filePdfUrl != null && this.filePdfUrl != "") {
        for (var item of this.filePdfUrl.split(',')) {
          if (["pdf", "PDF"].indexOf(this.getFileExtensions(item)) == -1) {
            // 保険ファイル拡張子はPDF必要です。
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_PDF'), showClose: true });
            return flag = false
          }
        }
      }
      //添付ファイルサイズ
      if (this.fileTotal / 1024 / 1024 > 10) {
        // 添付ファイルの総サイズを10M以内にしてください。
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_SIZECHECK'), showClose: true })
        return flag = false
      }
      //「はい」必須場合 対人保証
      if (this.persionalInsurance != 1) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_RADIO_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_I_VALIDITY')), showClose: true });
        return flag = false
      }
      //「はい」必須場合 対物保証
      if (this.othersInsurance != 1) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_RADIO_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_J_VALIDITY')), showClose: true });
        return flag = false
      }
      //「はい」必須場合 人身傷害補償
      if (this.personalInjuryCompensation != 1) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_RADIO_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_K_VALIDITY')), showClose: true });
        return flag = false
      }

      return flag
    },

    // 照片删除
    driveLicensePhoto1PhotoDelete() {
      this.photoDelete('driveLicensePhoto1')
    },
    driveLicensePhoto2PhotoDelete() {
      this.photoDelete('driveLicensePhoto2')
    },
    carVerificationPhotoPhotoDelete() {
      this.photoDelete('carVerificationPhoto')
    },
    insuranceExpPhotoPhotoDelete() {
      this.photoDelete('insuranceExpPhoto')
    },
    insuranceExpPhoto2PhotoDelete() {
      this.photoDelete('insuranceExpPhoto2')
    },

    // 删除确认
    photoDelete(itemName) {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.BTN_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(() => {
        //上传用list清空
        this[itemName + 'List'] = [];
        this[itemName + 'Url'] = '';
        this[itemName + 'Dialog'] = false;
        this[itemName + 'Image'] = {};
        this.changeFlg = true;
      }).catch(() => {

      })
    },
    //ALERT确认提示
    confirmAlert(msgs) {
      var msg = ''
      msg = '<span>' + msgs + '</span><br/>'
      this.$alert(msg, '', {
        confirmButtonText: 'OK',
        dangerouslyUseHTMLString: true,
        type: 'warning',
        center: true,
        showClose: false,
        customClass: 'confirmStyle',
      }).then(() => {

      })
    },
    //取得文件名的扩展名
    getFileExtensions(name) {
      //取到文件名开始到最后一个点的长度
      let fileName = name.lastIndexOf(".");
      //取到文件名长度
      let fileNameLength = name.length;
      //截取扩展名
      let fileExtensions = name.substring(fileName + 1, fileNameLength);
      return fileExtensions
    },
  },
  // 初期化自动调用
  created() {
    // 初期化函数调用
    this.query()
  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        //关闭照片查看器
        that.driveLicensePhoto1Dialog = false
        that.driveLicensePhoto2Dialog = false
        that.carVerificationPhotoDialog = false
        that.insuranceExpPhotoDialog = false
        that.insuranceExpPhoto2Dialog = false
      }
    })
  },
  watch: {

  },
}

</script>
<style>
/*panel下全部区域*/
.all_area_i0008 {
  margin-left: 0px;
  margin-top: 5px;
}
/*下半部入力框内部长度 第一行*/
.textRight_i0008 .el-input__inner {
  text-align: right;
  font-size: 12px;
}

/*下半部span样式*/
.input_span_i0008 {
  padding: 2px 0px 0px 21px;
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 40%;
  font-weight: 550;
  font-size: 15px;
}
/*下半部span用div样式*/
.div_span_i0008 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 35px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
}
/*下半部input用div样式*/
.div_input_i0008 {
  height: 60px;
  line-height: 0px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
}

.date_picker_i0008 {
  width: 40%;
  min-width: 40%;
  padding: 10px 0px 0px 0px;
  float: left;
  min-height: 40px;
  color: #ff0202;
  vertical-align: top;
}

/*下半部整体div样式*/
.el-detail_i0008 {
  /* overflow-y:auto; */
  width: 100%;
  height: 100%;
}

.photo_upload_i0008 .el-upload--picture-card {
  width: 45%;
  height: 43px;
  margin-top: 9px;
  margin-left: 6px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}

/* 图片样式 */
.photo_upload_i0008 .el-upload-list--picture-card .el-upload-list__item {
  width: 45%;
  height: 43px;
  margin-top: 9px;
  margin-left: 0px;
  margin-right: 0px;
  border: none;
}

/* 图片上传按钮样式 */
.photo_upload_i0008 .el-upload--picture-card i {
  margin-top: 7px;
  color: #409eff;
}
/* 去除上传图片动画 */
.photo_upload_i0008 .el-upload-list__item {
  transition: none !important;
}

/* 左边空图片蓝色边框 */
.photo_border_i0008 {
  float: left;
  width: 45%;
  height: 40px;
  margin-top: 19px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}
/* 左边空图片红色边框 */
.driveLicensePhoto1Css {
  float: left;
  width: 45%;
  height: 40px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.driveLicensePhoto2Css {
  float: left;
  width: 45%;
  height: 40px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
  margin-left: 0px;
}
/* 左边空图片红色边框 */
.carVerificationPhotoCss {
  float: left;
  width: 45%;
  height: 40px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.insuranceExpPhotoCss {
  float: left;
  width: 45%;
  height: 40px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.insuranceExpPhoto2Css {
  float: left;
  width: 45%;
  height: 40px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}

.div_input_i0008 .el-icon-circle-close:before {
  color: #fd270a;
}

.date_select_i0008 .el-input__inner {
  width: 130px;
}
.date_select_i0008.el-date-editor.el-input {
  width: 130px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0008.vue